<template>
    <!-- HEADER
			============================================= -->
			<header id="header" class="header tra-menu navbar-dark">
				<div class="header-wrapper">


					<!-- MOBILE HEADER -->
				    <div class="wsmobileheader clearfix">
				    	<span class="smllogo"><img :src="settingStore.modalLogo" alt="mobile-logo"/></span>
				    	<a id="wsnavtoggle" class="wsanimated-arrow"><span></span></a>
				 	</div>


				 	<!-- NAVIGATION MENU -->
				  	<div class="wsmainfull menu clearfix">
	    				<div class="wsmainwp clearfix">


	    					<!-- HEADER LOGO -->
	    					<div class="desktoplogo"><a href="/" class="logo-black"><img :src="settingStore.modalLogo" alt="header-logo"></a></div>
	    					<div class="desktoplogo"><a href="/" class="logo-white"><img :src="settingStore.modalLogo" alt="header-logo"></a></div>


	    					<!-- MAIN MENU -->
	      					<nav class="wsmenu clearfix">
	        					<ul class="wsmenu-list nav-stateblue-hover">
                                    <!-- SIMPLE NAVIGATION LINK -->
                                    <li class="nl-simple" aria-haspopup="true"><a href="/#howitworks">How It Works</a></li>

						          	<!-- SIMPLE NAVIGATION LINK -->
                                    <li class="nl-simple" aria-haspopup="true"><a href="/#features">Features</a></li>

						          	<!-- SIMPLE NAVIGATION LINK -->
                                    <li class="nl-simple" aria-haspopup="true"><a href="/#plan">Pricing</a></li>
                                    <li class="nl-simple" aria-haspopup="true"><a href="/#testimonial">Reviews</a></li>

						          	<!-- SIMPLE NAVIGATION LINK -->
							    	<li class="nl-simple" aria-haspopup="true"><a href="https://affiliates.creditfixrr.com/signup">Affiliate</a></li>


							    	<!-- SIMPLE NAVIGATION LINK -->
							    	<li class="nl-simple" aria-haspopup="true"><a href="/blog">Blogs</a></li>
							    	<li class="nl-simple" aria-haspopup="true"><a href="/e-book">Ebooks</a></li>


								    <!-- HEADER BUTTON -->
								    <li class="nl-simple" aria-haspopup="true">
								    	<a href="/register" class="btn btn-tra-grey stateblue-hover last-link">Get Started</a>
								    </li>
	        					</ul>
	        				</nav>	<!-- END MAIN MENU -->


	    				</div>
	    			</div>	<!-- END NAVIGATION MENU -->


				</div>     <!-- End header-wrapper -->
			</header>	<!-- END HEADER -->
</template>
<script>
    import { useSettingStore } from '../../stores/SettingStore.js'
    export default {
        compomenents:{

        },
        setup(){
            return{
                settingStore:useSettingStore()
            }
        }
    }
</script>
